<template>
  <div id="app">
    <router-view />
    <CookieNotice />
  </div>
</template>

<script>
import CookieNotice from "@/components/CookieNotice.vue";
import appConfig from "@/app.config";
import { notificationMethods } from "@/state/helpers";

export default {
  name: "app",
  components: { CookieNotice },
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | ${appConfig.title}` : appConfig.title;
    },
  },
  methods: {
    clearNotification: notificationMethods.clear,
  },
  watch: {
    /**
     * Clear the alert message on route change
     */
    $route() {
      // clear alert on location change
      this.clearNotification();
    },
  },
};
</script>
